import { first } from 'rxjs/operators'

import { Item, Record } from '@skinsoft/types'
import { itemSelectors, recordSelectors } from '@skinsoft/selectors'
import { dbCacheDown } from '../dexie/cache-down'
import { STATS_KEYS } from '../dexie/stats-keys'
import { OfflineDataFetcher } from '@skinsoft/offline'
import { ItemOfflineDataFetcher } from './item-offline-data-fetcher'
import { matchesRegex } from '@skinsoft/utils'

export class AuditRecordOfflineDataFetcher extends OfflineDataFetcher<Record>{
    private itemOfflineDataFetcher: ItemOfflineDataFetcher
    
    constructor() {
        super(dbCacheDown.auditRecord, STATS_KEYS.auditRecord)
        this.itemOfflineDataFetcher = new ItemOfflineDataFetcher()
    }

    protected async queryTextFilter(entity: Record, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()
        // record title
        // @ts-ignore
        const title: string = recordSelectors.recordIdentifier(entity);
        const titleMatch = title ? matchesRegex(queryText, title) : false;

        // record linked object identifier
        // @ts-ignore
        const linkedItemId: string = recordSelectors.linkedItemId(entity);
        const item: Item | null = linkedItemId ? await this.itemOfflineDataFetcher.fetchOneFromId(linkedItemId).pipe(first()).toPromise() : null
        const itemIdentifier = item ? itemSelectors.identifier(item, locale) : ""
        const itemIdentifierMatch = itemIdentifier ? matchesRegex(lowerCaseQueryText, itemIdentifier.toLowerCase()) : false;

        return titleMatch || itemIdentifierMatch;
    }
}